import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppReduxDispatch, AppReduxState } from "../redux-store";

export const useAppReduxDispatch = () => useDispatch<AppReduxDispatch>();
export const useAppReduxSelector: TypedUseSelectorHook<AppReduxState> =
  useSelector;
